import { apiClient } from './api';
import {
  BlacklistEntry,
  PagedResponse,
  AddBlacklistIpRequest,
  AddBlacklistPrefixRequest,
  UpdateBlacklistEntryRequest,
  BlacklistQueryRequest,
  BlacklistStats,
  DownloadTokenResponse,
  DownloadStatisticsResponse,
} from '../types/api';

export const blacklistService = {
  getAll: async (params: BlacklistQueryRequest): Promise<PagedResponse<BlacklistEntry>> => {
    const { data } = await apiClient.get('/blacklist', { params });
    return data;
  },

  getById: async (id: number): Promise<BlacklistEntry> => {
    const { data } = await apiClient.get(`/blacklist/${id}`);
    return data;
  },

  addIp: async (request: AddBlacklistIpRequest): Promise<BlacklistEntry> => {
    const { data } = await apiClient.post('/blacklist/ip', request);
    return data;
  },

  addPrefix: async (request: AddBlacklistPrefixRequest): Promise<BlacklistEntry> => {
    const { data } = await apiClient.post('/blacklist/prefix', request);
    return data;
  },

  update: async (id: number, request: UpdateBlacklistEntryRequest): Promise<void> => {
    await apiClient.put(`/blacklist/${id}`, request);
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/blacklist/${id}`);
  },

  checkIp: async (ip: string): Promise<{ isBlacklisted: boolean; entry?: BlacklistEntry }> => {
    const { data } = await apiClient.get(`/blacklist/check/${ip}`);
    return data;
  },

  exportList: async (): Promise<Blob> => {
    const { data } = await apiClient.get('/blacklist/export', { responseType: 'blob' });
    return data;
  },

  getStats: async (): Promise<BlacklistStats> => {
    const { data } = await apiClient.get('/blacklist/stats');
    return data;
  },

  getDownloadToken: async (): Promise<DownloadTokenResponse> => {
    const { data } = await apiClient.get('/blacklist/download-token');
    return data;
  },

  rotateDownloadToken: async (): Promise<DownloadTokenResponse> => {
    const { data } = await apiClient.post('/blacklist/download-token/rotate');
    return data;
  },

  getDownloadStatistics: async (days: number = 30): Promise<DownloadStatisticsResponse> => {
    const { data } = await apiClient.get('/blacklist/download-statistics', { params: { days } });
    return data;
  },
};
